import styled from 'styled-components'
import { color, fontSize } from 'utils/styledHelper'

import { ThemePropsType } from './types'

type ThemeFx = (props: ThemePropsType) => string

const SwitchWrapper = styled.div<{ background?: string | ThemeFx }>`
  position: relative;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background: ${(p) => p.background ?? color('dark700')};
  border-radius: 8px;
  margin: 0;
`

type SwitchLabelState = 'regular' | 'hover' | 'active'
type SwitchLabelProps = {
  active?: boolean // optional prop to disable switch
  activeColor?: string | ThemeFx // not selected, click over
  disabled?: boolean
  disabledColor?: string | ThemeFx // disabled text color
  hoverColor?: string | ThemeFx // not selected, mouse over
  regularColor?: string | ThemeFx // not selected, no mouse event
  selected: boolean
  selectedActiveColor?: string | ThemeFx // selected, click over
  selectedColor?: string | ThemeFx // selected, no mouse event
  selectedHoverColor?: string | ThemeFx // selected, mouse over
  selectedTextColor?: string | ThemeFx
  textColor?: string | ThemeFx
}
const getSwitchColor = (state: SwitchLabelState) => (props: SwitchLabelProps) => {
  if (props.disabled) {
    return props.disabledColor ?? color('dark400')
  }
  if (props.selected || state === 'hover') {
    return props.selectedTextColor ?? color('white')
  }
  return props.textColor ?? color('dark200')
}

const getSwitchBGColor = (state: SwitchLabelState) => (props: SwitchLabelProps) => {
  if (props.disabled) {
    return props.regularColor ?? 'transparent'
  }

  if ((props.active ?? true) && props.selected) {
    if (state === 'active') {
      return props.selectedActiveColor ?? props.selectedColor ?? 'white'
    }
    if (state === 'hover') {
      return props.selectedHoverColor ?? props.selectedColor ?? 'white'
    }
    return props.selectedColor ?? 'white'
  }

  if (state === 'active') {
    return props.activeColor ?? props.regularColor ?? color('dark900')
  }
  if (state === 'hover') {
    return props.hoverColor ?? props.regularColor ?? color('dark800')
  }
  return props.regularColor ?? 'transparent'
}

const SwitchLabel = styled.div<SwitchLabelProps>`
  flex: 1;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ?? false ? 'not-allowed' : 'pointer')};
  line-height: 150%;
  font-weight: 600;
  font-size: ${fontSize('md')};
  border-radius: 6px;
  margin: 2px;
  padding: 0.5rem;
  background-color: ${getSwitchBGColor('regular')};
  color: ${getSwitchColor('regular')};
  transition: background-color ${(p) => p.theme.transition.medium},
    color ${(p) => p.theme.transition.medium};

  &:hover {
    color: ${getSwitchColor('hover')};
    background-color: ${getSwitchBGColor('hover')};
  }

  &:active {
    background-color: ${getSwitchBGColor('active')};
  }
`

export { SwitchLabel, SwitchWrapper }
